/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import DatePickerInput from '../DatePickerInput/DatePickerInput.js';
import { FormContext } from '../FluidForm/FormContext.js';

const FluidDatePickerInput = /*#__PURE__*/React__default.forwardRef(function FluidDatePickerInput(_ref, ref) {
  let {
    ...other
  } = _ref;
  return /*#__PURE__*/React__default.createElement(FormContext.Provider, {
    value: {
      isFluid: true
    }
  }, /*#__PURE__*/React__default.createElement(DatePickerInput, _extends({
    ref: ref
  }, other)));
});

export { FluidDatePickerInput as default };
